export const bemClasses = Object.freeze({
    BASE: 'base',
    SMALL: 'small',
    M: 'm'
});
